import React from "react";

const CandidateConditionTags = ({
  dbs_conditions,
  nmc_gmc_conditions,
  visa_restrictions,
}) => {
  const conditions = [
    {
      label: "NMC/GMC conditions",
      show: nmc_gmc_conditions,
      bg: "bg-red",
      text: "text-white",
    },
    {
      label: "Visa restrictions",
      show: visa_restrictions,
      bg: "bg-red",
      text: "text-white",
    },
    {
      label: "DBS conditions",
      show: dbs_conditions,
      bg: "bg-red",
      text: "text-white",
    },
  ];

  return (
    <div className="mb-5 flex flex-wrap gap-2">
      {conditions.map((condition, index) =>
        condition.show ? (
          <span
            key={index}
            className={`${condition.bg} ${condition.text} rounded-lg px-2 py-1 text-xs font-semibold`}
          >
            {condition.label}
          </span>
        ) : null,
      )}
    </div>
  );
};

export default CandidateConditionTags;
